import React, { useState, useEffect } from "react";

const NavHader = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const wrapper = document.querySelector("#main-wrapper");
    if (!wrapper) return;

    const checkSidebarState = () => {
      const isMobile = window.innerWidth <= 768;
      const isOpen = isMobile 
        ? wrapper.classList.contains("menu-toggle") 
        : !wrapper.classList.contains("menu-toggle");
      setIsSidebarOpen(isOpen);
    };

    // Set initial state
    checkSidebarState();
    
    // Update on resize
    window.addEventListener("resize", checkSidebarState);

    // Observe class changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          checkSidebarState();
        }
      });
    });

    observer.observe(wrapper, { attributes: true });

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkSidebarState);
    };
  }, []);

  const handleSidebarToggle = () => {
    const wrapper = document.querySelector("#main-wrapper");
    if (wrapper) {
      wrapper.classList.toggle("menu-toggle");
    }
  };

  return (
    <div className="nav-header" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: isSidebarOpen ? 'flex-start' : 'center',
        padding: isSidebarOpen ? '0 24px' : '0',
        height: '4rem',
        zIndex: 100
    }}>
      <button
        onClick={handleSidebarToggle}
        className="header-sidebar-toggle"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          width: '24px',
          flexShrink: 0,
        }}
        aria-label={isSidebarOpen ? 'Cerrar menú' : 'Abrir menú'}
      >
        {isSidebarOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"/>
            <polyline points="9 18 3 12 9 6"/>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        )}
      </button>

      {isSidebarOpen && (
        <div 
          style={{ 
            color: '#fff', 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            marginLeft: '10px',
            whiteSpace: 'nowrap',
            textTransform: 'capitalize'
          }}
        >
          OTT Manager
        </div>
      )}
    </div>
  );
};

export default NavHader;
